// removed by extract-text-webpack-plugin
module.exports = {"Navigation":"_1CKJC","Wrapper":"_3428l","Primary":"_2rJ2-","Secondary":"_36u8f","SecondaryMobile":"_2utZD","Inner":"_1QwNO","ProceedContainer":"_25fz9","SmallImage":"_1J3Zn","CloseButton":"_2CgAD"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ReviewHotel/ReviewHotel.scss
// module id = 657
// module chunks = 0